import { useEffect, useState } from "react";
import { adminApi } from "@/admin/AdminAuthContext";
import AdminPageShell from "@/admin/AdminPageShell";
import { Download } from "lucide-react";

const AdminNewsletter = () => {
  const [subs, setSubs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminApi.get("/newsletter").then((res) => setSubs(res.data)).finally(() => setLoading(false));
  }, []);

  const exportCsv = () => {
    const rows = [["email", "brand", "status", "created_at"], ...subs.map((s) => [s.email, s.brand, s.status, s.created_at])];
    const csv = rows.map((r) => r.join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = "newsletter_subscribers.csv"; a.click();
  };

  return (
    <AdminPageShell
      title="Newsletter"
      description="Subscriber list is stored securely. Provider dispatch (Mailchimp/SendGrid) will connect once an API key is supplied in Settings."
      actions={<button onClick={exportCsv} className="btn-outline-silver btn-pill-sm" data-testid="admin-newsletter-export-btn"><Download size={14} /> Export CSV</button>}
      testId="admin-newsletter-page"
    >
      {loading ? <p className="text-small">Loading…</p> : (
        <div className="neu-panel overflow-hidden">
          <table className="w-full text-left">
            <thead><tr className="border-b" style={{ borderColor: "var(--gg-fine-border)" }}>
              <th className="p-4 text-small">Email</th><th className="p-4 text-small">List</th><th className="p-4 text-small">Status</th>
            </tr></thead>
            <tbody>
              {subs.map((s) => (
                <tr key={s.id} className="border-b" style={{ borderColor: "var(--gg-subtle-divider)" }} data-testid={`admin-newsletter-row-${s.id}`}>
                  <td className="p-4 text-body">{s.email}</td>
                  <td className="p-4 text-small">{s.brand}</td>
                  <td className="p-4 text-small" style={{ color: "var(--gg-logo-gold)" }}>{s.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {subs.length === 0 && <p className="text-small p-6">No subscribers yet.</p>}
        </div>
      )}
    </AdminPageShell>
  );
};

export default AdminNewsletter;
